export const ACCORDION_TAB_ACTIVE = 0;

export const ACCORDION_PANEL_HEIGHT = 0;
